<template>
  <component :is="configComponent" v-bind="configProps"></component>
</template>

<script>
  import Global from './global'
  import AnalogDevice from './analog-device'
  import Func from './func'
  import Interface from './interface'
  import Metadata from './metadata'
  import ModbusData from './modbus-data'
  import ModbusDataPoint from './modbus-data-point'
  import ModbusDevice from './modbus-device'
  import PlcData from './plc-data'
  import PlcDevice from './plc-device'
  import UploadData from './upload-data'
  import UploadDevice from './upload-device'
  import Upload from './upload'
  import Dlt645Device from './dlt645-device'
  import Dlt645Data from './dlt645-data'

  export default {
    data () {
      return {
        configComponent: '',
        configProps: ''
      }
    },
    created () {
      this._componentCache = {}
      this._updateForm = (component, props) => {
        this.configComponent = component
        this.configProps = props
      }

      this.$emitter.on('updateForm', this._updateForm)
    },
    destroyed () {
      this.$emitter.removeListener('updateForm', this._updateForm)
    },
    components: {
      Global,
      AnalogDevice,
      Func,
      Interface,
      Metadata,
      ModbusData,
      ModbusDataPoint,
      ModbusDevice,
      PlcData,
      PlcDevice,
      UploadData,
      UploadDevice,
      Upload,
      Dlt645Device,
      Dlt645Data
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/index.vue